import requestReducerFactory from './request-reducer';

const reducersFactory = (actionTypes) =>
    Object.keys(actionTypes).reduce(
        (prev, actionType) => ({
            ...prev,
            [actionType]: requestReducerFactory(actionTypes[actionType]),
        }),
        {},
    );

const createReducers = (actionTypes) => {
    const reducers = reducersFactory(actionTypes);
    return (state = {}, action) =>
        Object.keys(reducers).reduce(
            (prev, reducer) => ({
                ...prev,
                [reducer]: reducers[reducer](prev[reducer], action),
            }),
            state,
        );
};

export default createReducers;
